module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_rogaland_neg.7be81bac.svg";